import React from 'react';

import { Chip } from '~/eds/src/components/Chip/Chip';
import { LoadingShimmer } from '~/eds/src/components/LoadingShimmer/LoadingShimmer';
import { NumberText } from '~/eds/src/components/NumberText/NumberText';
import { Uuid } from '~/types/Uuid';

import { usePollModelProgress } from './hooks/usePollModelProgress';

type ProgressMetric =
  | 'docsInScope'
  | 'docsProcessed'
  | 'status'
  | 'valuesFound';

interface Props {
  metric: ProgressMetric;
  modelId: Uuid;
}

export const ModelProgress = ({ metric, modelId }: Props) => {
  const { isLoading, progress, progressChip } = usePollModelProgress({
    modelId,
  });

  if (isLoading) {
    return <LoadingShimmer />;
  } else if (progress) {
    switch (metric) {
      case 'docsInScope':
      case 'docsProcessed':
      case 'valuesFound':
        const number = progress[metric];
        return <NumberText number={number} />;
      case 'status':
        return <Chip {...progressChip} />;
      default:
        return null;
    }
  } else {
    return null;
  }
};
